import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  PreloadAllModules,
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withPreloading,
} from '@angular/router';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import {
  NavigationActionTiming,
  NgxsRouterPluginModule,
} from '@ngxs/router-plugin';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { NgxsWebSocketPluginModule } from '@ngxs/websocket-plugin';
import { appRoutes } from './app.routes';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { MasterLocationsGlobalState } from '@embrace-it/master-locations-library';
import { provideCore } from '@embraceit/angularcore';
import { provideTolgeeForStandalone } from '@embraceit/angularcore/tms/tolgee';
import Aura from '@primeng/themes/aura';
import { provideUserIdleConfig } from 'angular-user-idle';
import { provideEnvironment } from 'master-locations-library/master-locations-library/src/lib/core/environments/environment.token';
import { provideRepositories } from 'master-locations-library/master-locations-library/src/lib/data/data.providers';
import { HttpDefaultInterceptor } from 'master-locations-library/master-locations-library/src/lib/presentation/base/utils/interceptors/default.interceptor';
import { HttpTenantInterceptor } from 'master-locations-library/master-locations-library/src/lib/presentation/base/utils/interceptors/tenant.interceptor';
import { HttpTokenInterceptor } from 'master-locations-library/master-locations-library/src/lib/presentation/base/utils/interceptors/token.interceptor';
import { HttpExternalUrlCleanupInterceptor } from 'master-locations-library/master-locations-library/src/lib/presentation/base/utils/interceptors/external-url-cleanup.interceptor';
import { AddEditPrivateLocationState } from 'master-locations-library/master-locations-library/src/lib/presentation/locations/add-edit-private-location/state/add-edit-private-location.state';
import { LocationsState } from 'master-locations-library/master-locations-library/src/lib/presentation/locations/state/locations.state';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom([
      // NGXS Configurations
      NgxsModule.forRoot([], {
        developmentMode: !isDevMode(),
        selectorOptions: { suppressErrors: true },
      }),
      NgxsFormPluginModule.forRoot(),
      NgxsStoragePluginModule.forRoot({
        storage: StorageOption.LocalStorage,
        keys: [
          MasterLocationsGlobalState,
          LocationsState,
          AddEditPrivateLocationState,
        ],
      }),
      NgxsLoggerPluginModule.forRoot({ disabled: !isDevMode() }),
      NgxsReduxDevtoolsPluginModule.forRoot({
        disabled: !isDevMode(),
      }),
      NgxsWebSocketPluginModule.forRoot(),
      NgxsModule.forFeature([
        MasterLocationsGlobalState,
        LocationsState,
        AddEditPrivateLocationState,
      ]),
      NgxsRouterPluginModule.forRoot({
        navigationActionTiming: NavigationActionTiming.PostActivation,
      }),
    ]),
    ...provideRepositories(),
    provideRouter(
      appRoutes,
      withEnabledBlockingInitialNavigation(),
      withPreloading(PreloadAllModules)
    ),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTenantInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpDefaultInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpExternalUrlCleanupInterceptor,
      multi: true,
    },
    provideEnvironment(environment),
    DialogService,
    MessageService,
    provideUserIdleConfig({ idle: 900, timeout: 1, ping: 100 }),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false || 'none',
          cssLayer: {
            name: 'primeng',
          },
        },
      },
    }),
    provideCore({
      mode: 'standalone',
    }),
    provideTolgeeForStandalone({
      translations: {
        languages: ['en'],
        defaultLanguage: 'en',
        fallbackNs: ['COMMON'],
        defaultNs: 'MLS',
        tenantNs: 'MLS',
        ...environment.tolgee,
      },
      enableDevTools: isDevMode(),
    }),
  ],
};
